import React, { createContext, useContext, useState, useEffect } from "react";
import { ConfigProvider, message, theme as AntTheme } from "antd";
import LogoDark from '../assets/svg/logoDarkTheme.svg'
import LogoLight from '../assets/svg/logoLightTheme.svg'
import { postRequest, getRequest } from "../Api/ApiCall";

const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  // Light and Dark Theme Configurations based on shared image
  const lightTheme = {
    mode: "light",
    background: "#FFFFFF", // Soft blue-gray background
    boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.1)", 
    border: "1px solid #E0E0E0", 
    cardBackground: "#EEEEEE", // White card background
    logo:LogoLight,
    textPrimary: "#1E293B", // Dark navy text
    textSecondary: "#64748B", // Muted gray text
    iconColor: "#2563EB", // Bright blue for icons
    scrollColor:'#f1f3f4',
    antAlgorithm: AntTheme.defaultAlgorithm, // Ant Design default theme
  };

  const darkTheme = {
    mode: "dark",
    background: "#363636", // Dark blue-gray background
    cardBackground: "#2C2C2C", // Deep grayish-blue card
    textPrimary: "#E5E7EB", // Light gray text
    logo:LogoDark,
    boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.1)", 
    border: "1px solid #404040", 
    textSecondary: "#94A3B8", // Muted blue-gray text
    iconColor: "#60A5FA", // Softer blue for icons
    scrollColor:'#4d4d4d',
    antAlgorithm: AntTheme.darkAlgorithm, // Ant Design dark theme
  };

  // State to manage theme mode
  const [theme, setTheme] = useState(lightTheme);
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [tourCompleted, setTourCompleted] = useState(false);
  const [userTheme, setUserTheme] = useState({});
  const [tourOpen, setTourOpen] = useState(false); 
  
  const usernames = ['VNDArwin.Parameswaran','Daniel Ingitaraj', 'Macnamara, Ed', 'Schulz, Douglas', 'VNDPrasanna.Asokan', 'VND.NithyaN'];
  // Function to toggle between light and dark themes
 
  const fetchUserTheme = async () => {
    try {
      if (!userTheme.email) return; 
      const response = await getRequest("/auth/userDetails", { emailId: userTheme.email });
  
      if (response?.data) {
        const { theme, tour } = response.data;
  
        const selectedTheme = theme === "dark" ? darkTheme : lightTheme;
        setTheme(selectedTheme);
        setTourCompleted(tour); // Update tourCompleted state
        setTourOpen(!tour)
      } else {
        openMessage("error", response?.error || "Failed to fetch user theme.");
      }
    } catch (error) {
      console.error("Error fetching user theme:", error);
      openMessage("error", error.message || "An unexpected error occurred while fetching theme.");
    }
  };

  useEffect(() => {
    if (userTheme.name) {
      fetchUserTheme();
    }
  }, [userTheme.name]);

  const updateUserTheme = async (themeMode, tourStatus = tourCompleted) => {
    try {
      const payload = {
        name: userTheme.name,
        email: userTheme.email,
        theme: themeMode, 
        tour: tourStatus,
      };
  
      const response = await postRequest("/auth/userDetails", payload);
  
      if (!response?.status) {
        openMessage("error", response.error || "Failed to update user settings.");
      }
      
      return response;
    } catch (error) {
      console.error("Error updating user settings:", error);
      openMessage("error", error.message || "An unexpected error occurred.");
    }
  };
  
  
  const toggleTheme = async () => {
    const newTheme = theme.mode === "dark" ? lightTheme : darkTheme;
    setTheme(newTheme);
  
    // Call API to update user's theme preference
    await updateUserTheme(newTheme.mode,tourCompleted);
  };
  
  
  

  // Message Alert
  const openMessage = (type, content) => {
    messageApi.open({ type, content });
  };

  return (
    <ThemeContext.Provider value={{ usernames,theme,tourOpen, setTourOpen, toggleTheme,tourCompleted, setTourCompleted, openMessage,setUserTheme, loading, setLoading,updateUserTheme}}>
      <ConfigProvider theme={{ algorithm: theme.antAlgorithm }}>
        {contextHolder}
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};
